// extracted by mini-css-extract-plugin
module.exports = {"hm3-body-wrapper":"vision_hm3-body-wrapper__27h4p","hm3-box3":"vision_hm3-box3__UaBvW","hm3-footer":"vision_hm3-footer__2ZI_j"};